import { Platform } from 'react-native'

let hostLiquidGlassEnabled = false

export const setLiquidGlassCapability = (enabled: boolean) => {
  hostLiquidGlassEnabled = enabled
}

// The host flag is required because JS cannot detect a binary built with a
// pre-iOS-26 SDK or opted out via UIDesignRequiresCompatibility.
export const isLiquidGlassEnabled = () =>
  hostLiquidGlassEnabled && Platform.OS === 'ios' && parseInt(String(Platform.Version), 10) >= 26
